/* eslint-disable @next/next/no-img-element */
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { isMobile } from 'react-device-detect';
import { REVIEWS_IO } from '../../config/constants/images';
import { REVIEWS_IO_ALT } from '../../config/text/text';
import { showNationalReviews } from '../../helpers/cookieSetter';
import { getShowReviews } from '../../helpers/deals';
import ThemeContext from '../../providers/ThemeProvider';
import Stars from '../_generic/stars/Stars';

const MainDealReviewOverview = ({
  deal,
  toReviews = () => false,
  isTravel = false,
}) => {
  const theme = useContext(ThemeContext);

  if (!getShowReviews(deal, isTravel)) {
    return null;
  }

  if ((!showNationalReviews() && !isTravel) || isMobile) return null;

  return (
    <>
      <div
        className="review-overview"
        onClick={toReviews}
        onKeyDown={(event) => event.key === 'Enter' && toReviews()}
        role="button"
        tabIndex="0"
      >
        {deal.reviewTitle && !isTravel && (
          <img
            alt={REVIEWS_IO_ALT}
            className="logo"
            height={50}
            src={REVIEWS_IO}
            width={50}
          />
        )}
        <div className="reviews-container">
          <div>
            <Stars value={deal.reviewSummary.average} />
          </div>

          <div className="review-overview__count">
            <span>
              {deal.reviewSummary.total || deal.reviews.length} Reviews
            </span>
          </div>
        </div>
      </div>

      <style jsx>{`
        .review-overview {
          display: flex;
          align-items: center;
          color: ${theme.colors.primary};
          padding: ${isMobile ? '5px 10px' : '5px'};
          margin-bottom: 8px;
        }
        .review-overview:hover {
          text-decoration: underline;
        }
        .review-overview__count {
          margin-left: 5px;
        }
        .reviews-container {
          display: flex;
          flex-wrap: wrap;
          padding-left: ${isMobile ? '15px' : '5px'};
        }
        :global(.main-deal-travel .review-overview) {
          flex-wrap: wrap;
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          :global(.main-deal-travel .review-overview .review-overview__count) {
            margin: 0px;
          }
        }
      `}</style>
    </>
  );
};

MainDealReviewOverview.propTypes = {
  deal: PropTypes.object,
  isTravel: PropTypes.bool,
  toReviews: PropTypes.func,
};

export default MainDealReviewOverview;
